/**
 * Timing for post-submit success micro-interactions (#53): a brief green
 * "Submitted!" / "Signed!" confirmation before the parent transitions to the
 * next step, so the moment feels deliberate instead of abrupt.
 *
 * Collapses to 0 (instant transition, no flash) when the user prefers reduced
 * motion — WCAG 2.3.3 (Animation from Interactions) / 2.2.2 friendly.
 */
export const SUCCESS_FLASH_MS = 600;

/** True when the OS/browser requests reduced motion. SSR- and test-safe
 *  (guards `window` / `matchMedia` so it returns false in the node env). */
export function prefersReducedMotion(): boolean {
  return (
    globalThis.window !== undefined &&
    typeof globalThis.matchMedia === 'function' &&
    globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}

/** Hold duration (ms) for the success flash: `full` normally, 0 under reduced
 *  motion so the transition is instant. */
export function successHoldMs(reducedMotion: boolean, full: number = SUCCESS_FLASH_MS): number {
  return reducedMotion ? 0 : full;
}
